/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface BaseSampleProblemDetails {
  title?: string | null;
  detail?: string | null;
  instance?: string | null;
  /** @format int32 */
  status?: number;
  type?: string | null;
  paypingTraceId?: string | null;
}

/**
 *
 *
 * 4001 = RequestValidation
 *
 * 4002 = PanMismatch
 *
 * 4003 = PaymentInfoNotFound
 *
 * 4004 = IpgIbanExtractionNotSupported
 *
 * 4005 = UserProfileNotFound
 *
 * 4006 = UserNotInitialized
 *
 * 4007 = VerifiedIbanNotRegisteredInUserProfile
 *
 * 4008 = InsufficientWalletBalance
 *
 * 4041 = DataNotFound
 *
 * 4091 = UserAlreadyInitialized
 *
 * 4092 = UserInitializationInProgress
 *
 * 4093 = PaymentAlreadyRefunded
 *
 * 4094 = PaymentRefundPendingRecharge
 *
 * 4095 = PaymentRefundInProgress
 *
 * 4096 = RefundNotCancelable
 *
 * 4097 = RefundNotReinitializable
 *
 * 5031 = PanInquiryFailure
 *
 * 5032 = IpgIbanExtractionFailure
 *
 * 5033 = RechargePaymentCreationFailure
 * @format int32
 */
export enum BusinessErrorTypeEnum {
  RequestValidation = 4001,
  PanMismatch = 4002,
  PaymentInfoNotFound = 4003,
  IpgIbanExtractionNotSupported = 4004,
  UserProfileNotFound = 4005,
  UserNotInitialized = 4006,
  VerifiedIbanNotRegisteredInUserProfile = 4007,
  InsufficientWalletBalance = 4008,
  DataNotFound = 4041,
  UserAlreadyInitialized = 4091,
  UserInitializationInProgress = 4092,
  PaymentAlreadyRefunded = 4093,
  PaymentRefundPendingRecharge = 4094,
  PaymentRefundInProgress = 4095,
  RefundNotCancelable = 4096,
  RefundNotReinitializable = 4097,
  PanInquiryFailure = 5031,
  IpgIbanExtractionFailure = 5032,
  RechargePaymentCreationFailure = 5033,
}

export type ConflictErrorMetadataPayload = object;

export interface CreateRechargeOperationResult {
  /** کد تراکنش پرداخت شارژ حساب */
  paymentCode?: string | null;
  /** لینک پرداخت شارژ حساب */
  paymentLink?: string | null;
  /**
   * کد عملیات شارژ حساب
   * @format uuid
   */
  code?: string;
}

export interface CreateRefundRequest {
  /**
   * مبلغ استرداد به تومان. جهت استرداد کل مبلغ پرداخت خالی ارسال شود
   * @format double
   */
  amount?: number | null;
  /** کد پرداخت */
  paymentCode?: string | null;
  /**
   * پرداخت کننده کارمزد
   *
   * 1 = Payer
   *
   * 2 = Business
   */
  wagePayer?: WagePayerEnum;
}

export interface CreateRefundResult {
  /**
   * کد عملبات استرداد
   * @format uuid
   */
  code?: string;
  /** آیا برای استرداد باید شارژ والت صورت بگیرد */
  isPendingRecharge?: boolean;
}

export interface CreateWithdrawRequest {
  /**
   * مبلغ برداشت به تومان. جهت برداشت کل موجودی والت خالی ارسال شود
   * @format double
   */
  amount?: number | null;
  /** شماره شبا مقصد برداشت از والت. جهت واریز به شماره شبای ثبت شده در پروفایل خالی ارسال گردد */
  iban?: string | null;
}

/** Withdraw creation result */
export interface CreateWithdrawResult {
  /**
   * کد عملبات برداشت از والت استرداد
   * @format uuid
   */
  code?: string;
  /**
   * مقدار برداشت از ولت استرداد پس از کسر کارمزد
   * @format double
   */
  amount?: number;
  /**
   * کارمزد برداشت از ولت استرداد
   * @format double
   */
  wage?: number;
  /** شماره شبای مقصد انتقال برداشت از ولت استرداد */
  iban?: string | null;
}

export interface GetRefundListRequest {
  /**
   * تعداد آیتم های یک صفحه از نتایج
   * @format int32
   */
  pageSize?: number | null;
  /**
   * شماره صفحه. مقدار پیش فرض : ۱
   * @format int32
   */
  pageNumber?: number | null;
  /** کد های پرداخت جهت استفاده در فیلتر */
  paymentCodes?: string[] | null;
  /** وضعیت های استرداد جهت استفاده در فیلتر */
  states?: RefundOperationStateEnum[] | null;
  /**
   * تاریخ ساخت از
   * @format date-time
   */
  creationDateFrom?: string | null;
  /**
   * تاریخ ساخت تا
   * @format date-time
   */
  creationDateTo?: string | null;
  /**
   * حداقل مبلغ استرداد
   * @format double
   */
  minAmount?: number | null;
  /**
   * حداکثر مبلغ استرداد
   * @format double
   */
  maxAmount?: number | null;
  /** شماره کارت */
  pan?: string | null;
  /** لیست اطلاعات مورد نیاز مرتب سازی نتایج */
  orders?: OrderDetails[] | null;
}

export interface GetRefundListResult {
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  pageNumer?: number;
  /** @format int64 */
  totalCount?: number;
  data?: RefundInfo[] | null;
}

export interface GetServiceConfigurationResult {
  /** درگاه پرداخت های پشتیبانی شده */
  supportedIpgTypes?: PaymentIpgTypeEnum[] | null;
}

export interface GetUserConfigurationResult {
  /**
   * نوع آماده سازی سرویس ریفاند برای کاربر
   *
   * 1 = AllIpgTypesAndPanInquiry
   *
   * 2 = LimitUserToSupportedIpgTypesOnly
   */
  userInitializationType?: UserInitializationTypeEnum;
  /**
   * نوع کارمزد
   *
   * 0 = Fixed
   *
   * 1 = Percentage
   */
  wageType?: WageTypeEnum;
  /**
   * مقدار کارمزد
   * @format double
   */
  wageValue?: number;
  /**
   * حداقل کارمزد درصدی
   * @format double
   */
  minPercentageWage?: number;
  /**
   * حداکثر کارمزد درصدی
   * @format double
   */
  maxPercentageWage?: number;
  /**
   * تاریخ ساخت
   * @format date-time
   */
  creationDateTime?: string;
  /** راه اندازی اتوماتیک استرداد های در انتظار پس از شارژ مجدد‌ */
  autoInitializePendingRefunds?: boolean;
}

export interface GetWalletBalanceResult {
  /**
   * موجودی کل به تومان
   * @format double
   */
  totalBalance?: number;
  /**
   * کل مقدار مسدودی کیف پول به تومان
   * @format double
   */
  totalBlocked?: number;
  /**
   * موجودی قابل دسترسی به تومان
   * @format double
   */
  accessibleBalance?: number;
  /** واحد ارز مورد استفاده کیف پول */
  currency?: string | null;
}

export interface InitializeUserRequest {
  /**
   * نوع آماده سازی سرویس ریفاند برای کاربر
   *
   * 1 = AllIpgTypesAndPanInquiry
   *
   * 2 = LimitUserToSupportedIpgTypesOnly
   */
  userInitializationType?: UserInitializationTypeEnum;
}

/** اطلاعات مرتب سازی */
export interface OrderDetails {
  /** نام فیلد مرتب سازی بر اساس ان */
  property?: string | null;
  /**
   *
   *
   * 0 = ASC
   *
   * 1 = DESC
   */
  direction?: OrderDirectionEnum;
}

/**
 *
 *
 * 0 = ASC
 *
 * 1 = DESC
 * @format int32
 */
export enum OrderDirectionEnum {
  ASC = 0,
  DESC = 1,
}

/**
 *
 *
 * 0 = Default
 *
 * 1 = Pec
 *
 * 6 = Mellat
 *
 * 7 = Sadad
 *
 * 8 = Pep
 *
 * 10 = Mabna
 *
 * 15 = Saman
 * @format int32
 */
export enum PaymentIpgTypeEnum {
  Default = 0,
  Pec = 1,
  Mellat = 6,
  Sadad = 7,
  Pep = 8,
  Mabna = 10,
  Saman = 15,
}

export interface RefundInfo {
  /**
   * کد
   * @format uuid
   */
  code?: string;
  /**
   * وضعیت درخواست استرداد
   *
   * 1 = Created
   *
   * 2 = PendingBlockage
   *
   * 3 = PreparedToProcess
   *
   * 4 = ProcessingRefund
   *
   * 5 = RefundFailed
   *
   * 6 = RefundSucceeded
   *
   * -1 = Cancelled
   */
  state?: RefundOperationStateEnum;
  /** وضعیت */
  localizedState?: string | null;
  /** کد پرداخت */
  paymentCode?: string | null;
  /**
   * مبلغ درخواست شده به تومان
   * @format double
   */
  requestedAmount?: number;
  /**
   * مبلغ استرداد به تومان
   * @format double
   */
  refundAmount?: number;
  /**
   * کارمزد استرداد به تومان
   * @format double
   */
  refundWage?: number;
  /**
   * پرداخت کننده کارمزد
   *
   * 1 = Payer
   *
   * 2 = Business
   */
  wagePayer?: WagePayerEnum;
  /** پرداخت کننده کارمزد */
  localizedWagePayer?: string | null;
  /** شماره کارت ماسک شده پرداخت کننده */
  maskedPAN?: string | null;
  /**
   * تاریخ و زمان ساخت عملیات
   * @format date-time
   */
  creationDateTime?: string;
  /**
   * تاریخ و زمان آماده شدن عملیات
   * @format date-time
   */
  preparationDateTime?: string | null;
  /**
   * تاریخ و زمان شروع فرآیند استرداد
   * @format date-time
   */
  processStartDateTime?: string | null;
  /**
   * تاریخ و زمان شکست فرآیند استرداد
   * @format date-time
   */
  failureDateTime?: string | null;
  /**
   * تاریخ و زمان موفقیت فرآیند استرداد
   * @format date-time
   */
  successDateTime?: string | null;
  /**
   * تاریخ و زمان لغو عملیات
   * @format date-time
   */
  cancellationDateTime?: string | null;
  /** شناسه مرجع انتقال وجه */
  transferReference?: string | null;
  /** کد پیگیری بانکی تراکنش */
  bankTrackingCode?: string | null;
}

/**
 * وضعیت درخواست استرداد
 *
 * 1 = Created
 *
 * 2 = PendingBlockage
 *
 * 3 = PreparedToProcess
 *
 * 4 = ProcessingRefund
 *
 * 5 = RefundFailed
 *
 * 6 = RefundSucceeded
 *
 * -1 = Cancelled
 * @format int32
 */
export enum RefundOperationStateEnum {
  Created = 1,
  PendingBlockage = 2,
  PreparedToProcess = 3,
  ProcessingRefund = 4,
  RefundFailed = 5,
  RefundSucceeded = 6,
  Cancelled = -1,
}

export interface SampleBadRequestProblemDetails {
  title?: string | null;
  detail?: string | null;
  instance?: string | null;
  /** @format int32 */
  status?: number;
  type?: string | null;
  paypingTraceId?: string | null;
  /**
   *
   *
   * 4001 = RequestValidation
   *
   * 4002 = PanMismatch
   *
   * 4003 = PaymentInfoNotFound
   *
   * 4004 = IpgIbanExtractionNotSupported
   *
   * 4005 = UserProfileNotFound
   *
   * 4006 = UserNotInitialized
   *
   * 4007 = VerifiedIbanNotRegisteredInUserProfile
   *
   * 4008 = InsufficientWalletBalance
   *
   * 4041 = DataNotFound
   *
   * 4091 = UserAlreadyInitialized
   *
   * 4092 = UserInitializationInProgress
   *
   * 4093 = PaymentAlreadyRefunded
   *
   * 4094 = PaymentRefundPendingRecharge
   *
   * 4095 = PaymentRefundInProgress
   *
   * 4096 = RefundNotCancelable
   *
   * 4097 = RefundNotReinitializable
   *
   * 5031 = PanInquiryFailure
   *
   * 5032 = IpgIbanExtractionFailure
   *
   * 5033 = RechargePaymentCreationFailure
   */
  errorCode?: BusinessErrorTypeEnum;
  errors?: Record<string, string | null>;
}

export interface SampleConflictProblemDetails {
  title?: string | null;
  detail?: string | null;
  instance?: string | null;
  /** @format int32 */
  status?: number;
  type?: string | null;
  paypingTraceId?: string | null;
  /**
   *
   *
   * 4001 = RequestValidation
   *
   * 4002 = PanMismatch
   *
   * 4003 = PaymentInfoNotFound
   *
   * 4004 = IpgIbanExtractionNotSupported
   *
   * 4005 = UserProfileNotFound
   *
   * 4006 = UserNotInitialized
   *
   * 4007 = VerifiedIbanNotRegisteredInUserProfile
   *
   * 4008 = InsufficientWalletBalance
   *
   * 4041 = DataNotFound
   *
   * 4091 = UserAlreadyInitialized
   *
   * 4092 = UserInitializationInProgress
   *
   * 4093 = PaymentAlreadyRefunded
   *
   * 4094 = PaymentRefundPendingRecharge
   *
   * 4095 = PaymentRefundInProgress
   *
   * 4096 = RefundNotCancelable
   *
   * 4097 = RefundNotReinitializable
   *
   * 5031 = PanInquiryFailure
   *
   * 5032 = IpgIbanExtractionFailure
   *
   * 5033 = RechargePaymentCreationFailure
   */
  errorCode?: BusinessErrorTypeEnum;
  metadata?: ConflictErrorMetadataPayload;
}

export interface SampleDataNotFoundProblemDetails {
  title?: string | null;
  detail?: string | null;
  instance?: string | null;
  /** @format int32 */
  status?: number;
  type?: string | null;
  paypingTraceId?: string | null;
  /**
   *
   *
   * 4001 = RequestValidation
   *
   * 4002 = PanMismatch
   *
   * 4003 = PaymentInfoNotFound
   *
   * 4004 = IpgIbanExtractionNotSupported
   *
   * 4005 = UserProfileNotFound
   *
   * 4006 = UserNotInitialized
   *
   * 4007 = VerifiedIbanNotRegisteredInUserProfile
   *
   * 4008 = InsufficientWalletBalance
   *
   * 4041 = DataNotFound
   *
   * 4091 = UserAlreadyInitialized
   *
   * 4092 = UserInitializationInProgress
   *
   * 4093 = PaymentAlreadyRefunded
   *
   * 4094 = PaymentRefundPendingRecharge
   *
   * 4095 = PaymentRefundInProgress
   *
   * 4096 = RefundNotCancelable
   *
   * 4097 = RefundNotReinitializable
   *
   * 5031 = PanInquiryFailure
   *
   * 5032 = IpgIbanExtractionFailure
   *
   * 5033 = RechargePaymentCreationFailure
   */
  errorCode?: BusinessErrorTypeEnum;
}

export interface SampleServiceUnavailableProblemDetails {
  title?: string | null;
  detail?: string | null;
  instance?: string | null;
  /** @format int32 */
  status?: number;
  type?: string | null;
  paypingTraceId?: string | null;
  /**
   *
   *
   * 4001 = RequestValidation
   *
   * 4002 = PanMismatch
   *
   * 4003 = PaymentInfoNotFound
   *
   * 4004 = IpgIbanExtractionNotSupported
   *
   * 4005 = UserProfileNotFound
   *
   * 4006 = UserNotInitialized
   *
   * 4007 = VerifiedIbanNotRegisteredInUserProfile
   *
   * 4008 = InsufficientWalletBalance
   *
   * 4041 = DataNotFound
   *
   * 4091 = UserAlreadyInitialized
   *
   * 4092 = UserInitializationInProgress
   *
   * 4093 = PaymentAlreadyRefunded
   *
   * 4094 = PaymentRefundPendingRecharge
   *
   * 4095 = PaymentRefundInProgress
   *
   * 4096 = RefundNotCancelable
   *
   * 4097 = RefundNotReinitializable
   *
   * 5031 = PanInquiryFailure
   *
   * 5032 = IpgIbanExtractionFailure
   *
   * 5033 = RechargePaymentCreationFailure
   */
  errorCode?: BusinessErrorTypeEnum;
}

/**
 * نوع آماده سازی سرویس ریفاند برای کاربر
 *
 * 1 = AllIpgTypesAndPanInquiry
 *
 * 2 = LimitUserToSupportedIpgTypesOnly
 * @format int32
 */
export enum UserInitializationTypeEnum {
  AllIpgTypesAndPanInquiry = 1,
  LimitUserToSupportedIpgTypesOnly = 2,
}

/**
 * پرداخت کننده کارمزد
 *
 * 1 = Payer
 *
 * 2 = Business
 * @format int32
 */
export enum WagePayerEnum {
  Payer = 1,
  Business = 2,
}

/**
 * نوع کارمزد
 *
 * 0 = Fixed
 *
 * 1 = Percentage
 * @format int32
 */
export enum WageTypeEnum {
  Fixed = 0,
  Percentage = 1,
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title v1
 * @version v1
 *
 * Version 1 of refund endpoints
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v1 = {
    /**
     * No description
     *
     * @tags Recharge
     * @name CreateRechargeOperationWithAmountWithCancellationTokenPost
     * @summary ساخت عملیات شارژ حساب
     * @request POST:/v1/refund/recharge/Create
     * @secure
     */
    createRechargeOperationWithAmountWithCancellationTokenPost: (
      query?: {
        /**
         * مبلغ شارژ حساب به تومان
         * @format double
         */
        amount?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        CreateRechargeOperationResult,
        | SampleBadRequestProblemDetails
        | void
        | SampleDataNotFoundProblemDetails
        | SampleConflictProblemDetails
        | BaseSampleProblemDetails
        | SampleServiceUnavailableProblemDetails
      >({
        path: `/v1/refund/recharge/Create`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Refund
     * @name GetServiceConfigurationWithCancellationTokenGet
     * @summary گرفتن تنظیمات کلی سرویس ریفاند
     * @request GET:/v1/refund/ServiceConfiguration
     * @secure
     */
    getServiceConfigurationWithCancellationTokenGet: (params: RequestParams = {}) =>
      this.request<
        GetServiceConfigurationResult,
        | SampleBadRequestProblemDetails
        | void
        | SampleDataNotFoundProblemDetails
        | SampleConflictProblemDetails
        | BaseSampleProblemDetails
        | SampleServiceUnavailableProblemDetails
      >({
        path: `/v1/refund/ServiceConfiguration`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Refund
     * @name GetUserConfigurationWithCancellationTokenGet
     * @summary گرفتن تنظیمات ریفاند کاربر جاری
     * @request GET:/v1/refund/UserConfiguration
     * @secure
     */
    getUserConfigurationWithCancellationTokenGet: (params: RequestParams = {}) =>
      this.request<
        GetUserConfigurationResult,
        | SampleBadRequestProblemDetails
        | void
        | SampleDataNotFoundProblemDetails
        | SampleConflictProblemDetails
        | BaseSampleProblemDetails
        | SampleServiceUnavailableProblemDetails
      >({
        path: `/v1/refund/UserConfiguration`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Refund
     * @name InitializeUserWithRequestModelWithCancellationTokenPost
     * @summary راه اندازی سرویس استرداد برای کاربر
     * @request POST:/v1/refund/InitializeUser
     * @secure
     */
    initializeUserWithRequestModelWithCancellationTokenPost: (
      data: InitializeUserRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        void,
        | SampleBadRequestProblemDetails
        | void
        | SampleDataNotFoundProblemDetails
        | SampleConflictProblemDetails
        | BaseSampleProblemDetails
        | SampleServiceUnavailableProblemDetails
      >({
        path: `/v1/refund/InitializeUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Refund
     * @name GetWalletBalanceWithCancellationTokenGet
     * @summary دریافت موجودی کیف پول استرداد
     * @request GET:/v1/refund/Balance
     * @secure
     */
    getWalletBalanceWithCancellationTokenGet: (params: RequestParams = {}) =>
      this.request<
        GetWalletBalanceResult,
        | SampleBadRequestProblemDetails
        | void
        | SampleDataNotFoundProblemDetails
        | SampleConflictProblemDetails
        | BaseSampleProblemDetails
        | SampleServiceUnavailableProblemDetails
      >({
        path: `/v1/refund/Balance`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags Refund
 * @name CreateRefundWithRequestModelWithCancellationTokenPost
 * @summary ساخت عملیات استرداد  
این سرویس اصلی ساخت عملیات استرداد و برای پرداخت هایی است که درگاره پرداخت آنها قابلبت دریافت اطلاعات پرداخت کننده را پشتیبانی میکند  
در این سرویس استرداد به شماره کارت پرداخت کننده دریافت شده از درگاه واریز میشود
 * @request POST:/v1/refund/Create
 * @secure
 */
    createRefundWithRequestModelWithCancellationTokenPost: (data: CreateRefundRequest, params: RequestParams = {}) =>
      this.request<
        CreateRefundResult,
        | SampleBadRequestProblemDetails
        | void
        | SampleDataNotFoundProblemDetails
        | SampleConflictProblemDetails
        | BaseSampleProblemDetails
        | SampleServiceUnavailableProblemDetails
      >({
        path: `/v1/refund/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Refund
     * @name CancelRefundWithCodeWithCancellationTokenPost
     * @summary لفو عملیات استرداد. لفو عملیات تا قبل از ثبت دستور پرداخت امکان پذیر است
     * @request POST:/v1/refund/{code}/CancelPending
     * @secure
     */
    cancelRefundWithCodeWithCancellationTokenPost: (code: string, params: RequestParams = {}) =>
      this.request<
        void,
        | SampleBadRequestProblemDetails
        | void
        | SampleDataNotFoundProblemDetails
        | SampleConflictProblemDetails
        | BaseSampleProblemDetails
        | SampleServiceUnavailableProblemDetails
      >({
        path: `/v1/refund/${code}/CancelPending`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Refund
     * @name ReinitializeRefundWithCodeWithCancellationTokenPost
     * @summary راه اندازی مجدد عملیات استرداد در اتنظار شارژ حساب
     * @request POST:/v1/refund/{code}/ReinitializePending
     * @secure
     */
    reinitializeRefundWithCodeWithCancellationTokenPost: (code: string, params: RequestParams = {}) =>
      this.request<
        void,
        | SampleBadRequestProblemDetails
        | void
        | SampleDataNotFoundProblemDetails
        | SampleConflictProblemDetails
        | BaseSampleProblemDetails
        | SampleServiceUnavailableProblemDetails
      >({
        path: `/v1/refund/${code}/ReinitializePending`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Refund
     * @name GetRefundInfoWithCodeWithCancellationTokenGet
     * @summary دریافت اطلاعات عملیات استرداد کاربر
     * @request GET:/v1/refund/{code}
     * @secure
     */
    getRefundInfoWithCodeWithCancellationTokenGet: (code: string, params: RequestParams = {}) =>
      this.request<
        RefundInfo,
        | SampleBadRequestProblemDetails
        | void
        | SampleDataNotFoundProblemDetails
        | SampleConflictProblemDetails
        | BaseSampleProblemDetails
        | SampleServiceUnavailableProblemDetails
      >({
        path: `/v1/refund/${code}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Refund
     * @name GetRefundListWithRequestModelWithCancellationTokenPost
     * @summary دریافت لیست عملیات های استرداد کاربر با قابلیت فیلتر و صفحه بندی
     * @request POST:/v1/refund
     * @secure
     */
    getRefundListWithRequestModelWithCancellationTokenPost: (data: GetRefundListRequest, params: RequestParams = {}) =>
      this.request<
        GetRefundListResult,
        | SampleBadRequestProblemDetails
        | void
        | SampleDataNotFoundProblemDetails
        | SampleConflictProblemDetails
        | BaseSampleProblemDetails
        | SampleServiceUnavailableProblemDetails
      >({
        path: `/v1/refund`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Refund
     * @name GetLastetRefundInfoByPaymentCodeWithPaymentCodeWithCancellationTokenGet
     * @summary دریافت اطلاعات آخرین عملیات استرداد کاربر با کد پرداخت مشخص
     * @request GET:/v1/refund/LatestByPaymentCode/{paymentCode}
     * @secure
     */
    getLastetRefundInfoByPaymentCodeWithPaymentCodeWithCancellationTokenGet: (
      paymentCode: string,
      params: RequestParams = {},
    ) =>
      this.request<
        RefundInfo,
        | SampleBadRequestProblemDetails
        | void
        | SampleDataNotFoundProblemDetails
        | SampleConflictProblemDetails
        | BaseSampleProblemDetails
        | SampleServiceUnavailableProblemDetails
      >({
        path: `/v1/refund/LatestByPaymentCode/${paymentCode}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Withdraw
     * @name CreateWithdrawWithRequestModelWithCancellationTokenPost
     * @summary ساخت عملیات برداشت از والت استرداد
     * @request POST:/v1/refund/withdraw/Create
     * @secure
     */
    createWithdrawWithRequestModelWithCancellationTokenPost: (
      data: CreateWithdrawRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        CreateWithdrawResult,
        | SampleBadRequestProblemDetails
        | void
        | SampleDataNotFoundProblemDetails
        | SampleConflictProblemDetails
        | BaseSampleProblemDetails
        | SampleServiceUnavailableProblemDetails
      >({
        path: `/v1/refund/withdraw/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Withdraw
     * @name ConfirmWithdrawWithCodeWithCancellationTokenPost
     * @summary تایید عملیات برداشت از والت استرداد
     * @request POST:/v1/refund/withdraw/{code}/Confirm
     * @secure
     */
    confirmWithdrawWithCodeWithCancellationTokenPost: (code: string, params: RequestParams = {}) =>
      this.request<
        void,
        | SampleBadRequestProblemDetails
        | void
        | SampleDataNotFoundProblemDetails
        | SampleConflictProblemDetails
        | BaseSampleProblemDetails
        | SampleServiceUnavailableProblemDetails
      >({
        path: `/v1/refund/withdraw/${code}/Confirm`,
        method: "POST",
        secure: true,
        ...params,
      }),
  };
}
